import type { TrainingModule } from "../types";
import { mountBattleProcedureRunner } from "./runner-ui";

export const battleProcedureModule: TrainingModule = {
  id: "battle-procedure",
  title: "Battle Procedure Runner",
  featureFlag: "battleProcedure",
  render: () => ({
    kind: "content",
    heading: "Battle Procedure Runner",
    body: "Run battle procedure end to end, timed. Everything you type is captured and exported to this device. Nothing is scored.",
    mount: mountBattleProcedureRunner,
  }),
};
